import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useVpSnackbar } from '../../vp-ui';
import api from '../../utils/api';

import { GET_APP_SUMO_CODES } from '../../constants/endpoints';
import { APP_SUMO_CODES } from './queries';

const updateAppSumoCode = (data) => api.put(GET_APP_SUMO_CODES, data);

export const useUpdateAppSumoCode = (onComplete) => {
  const { addSnackbarError, addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(updateAppSumoCode, {
    onSuccess: (data) => {
      const message = data?.errMessage;

      if (message) {
        return addSnackbarError({ message, title: 'Invalid AppSumo Code' });
      }

      queryClient.invalidateQueries([APP_SUMO_CODES]);
      addSnackbarSuccess({ message: 'Successfully Added AppSumo Code' });
      onComplete && onComplete();
    },
    onError: (error) => {
      addSnackbarError({ error, title: 'Error Adding AppSumo Code' });
    }
  });
};

const getAppSumoCodes = () => api.get(GET_APP_SUMO_CODES);

export const useGetAppSumoCodes = () => {
  return useQuery([APP_SUMO_CODES], getAppSumoCodes);
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useAppSumoData.js